import {lazyComponent} from 'coreUtils/adapters/lazy';

const EditProfilePopup = lazyComponent(() => import('./EditProfilePopup'));

export {EditProfilePopup as default};
